module.exports = __webpack_public_path__ + "static/img/feature_3.d512400.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/feature_3.png
// module id = uZn9
// module chunks = 0